export default () => ({
    open: false,
    toggleOpen() {

        this.open = ! this.open;

    },
    close() {
        this.open = false;
    },
    get class() {
        return this.open ? 'open' : ''
    }
})